 
// 🎉 LevelCompleteScene - 90s Style Level Complete
// Celebrates level completion with retro style

import Phaser from 'phaser';
import { gameState } from '../game/state.js';
import { GAME_CONFIG } from '../game/config.js';

export default class LevelCompleteScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LevelCompleteScene' });
  }

  create() {
    const { width, height } = this.scale;
    
    console.log('🎉 Level Complete Scene loaded');
    
    // Colorful background
    this.add.rectangle(width/2, height/2, width, height, GAME_CONFIG.SPRITES.COLORS.MARIO_GREEN);
    
    // Add celebration clouds
    for (let i = 0; i < 4; i++) {
      this.add.image(i * 200 + 100, 80, 'cloud')
        .setScale(3)
        .setTint(0xFFFFFF);
    }
    
    // Main title
    this.add.text(width/2, height * 0.2, '🎉 LEVEL COMPLETE! 🎉', {
      fontSize: '24px',
      fontFamily: 'Arial, sans-serif',
      color: '#FFFFFF',
      stroke: '#000000',
      strokeThickness: 4
    }).setOrigin(0.5);
    
    // Level info
    this.add.text(width/2, height * 0.3, `LEVEL ${gameState.level} FINISHED`, {
      fontSize: '16px',
      fontFamily: 'Arial, sans-serif',
      color: '#FFD700',
      stroke: '#000000',
      strokeThickness: 2
    }).setOrigin(0.5);
    
    // Score info
    const levelScore = gameState.levelScores[gameState.level] || 0;
    
    this.add.text(width/2, height * 0.45, `LEVEL SCORE: ${levelScore}`, {
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
      color: '#FFFFFF',
      stroke: '#000000',
      strokeThickness: 2
    }).setOrigin(0.5);
    
    this.add.text(width/2, height * 0.55, `TOTAL SCORE: ${gameState.score}`, {
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
      color: '#FFFFFF',
      stroke: '#000000',
      strokeThickness: 2
    }).setOrigin(0.5);
    
    // Character-specific message
    const character = gameState.getCharacterInfo();
    const messages = {
      1: `Great job ${character.name}! Ready for the ceremony?`,
      2: `Perfect ceremony! Time for the party!`
    };
    
    this.add.text(width/2, height * 0.7, messages[gameState.level] || 'Well done!', {
      fontSize: '10px',
      fontFamily: 'Arial, sans-serif',
      color: '#FFFFFF',
      stroke: '#000000',
      strokeThickness: 1,
      align: 'center',
      wordWrap: { width: width - 100 }
    }).setOrigin(0.5);
    
    // Continue button
    const continueBtn = this.add.graphics()
      .fillStyle(GAME_CONFIG.SPRITES.COLORS.MARIO_YELLOW)
      .fillRoundedRect(width/2 - 100, height * 0.85 - 20, 200, 40, 8)
      .lineStyle(3, GAME_CONFIG.SPRITES.COLORS.UI_BLACK)
      .strokeRoundedRect(width/2 - 100, height * 0.85 - 20, 200, 40, 8)
      .setInteractive(new Phaser.Geom.Rectangle(width/2 - 100, height * 0.85 - 20, 200, 40), Phaser.Geom.Rectangle.Contains)
      .on('pointerdown', () => this.nextLevel());
    
    this.add.text(width/2, height * 0.85, 'NEXT LEVEL', {
      fontSize: '12px',
      fontFamily: 'Arial, sans-serif',
      color: '#000000'
    }).setOrigin(0.5);
    
    // Celebration animation
    this.createCelebrationEffects();
  }

  createCelebrationEffects() {
    const { width, height } = this.scale;
    
    // Falling hearts and stars
    for (let i = 0; i < 20; i++) {
      this.time.delayedCall(i * 200, () => {
        const isHeart = Math.random() > 0.5;
        const particle = this.add.image(
          Math.random() * width,
          -20,
          isHeart ? 'heart' : 'star'
        ).setScale(2);
        
        this.tweens.add({
          targets: particle,
          y: height + 20,
          x: particle.x + (Math.random() - 0.5) * 100,
          rotation: Math.PI * 2,
          duration: 3000,
          ease: 'Linear',
          onComplete: () => particle.destroy()
        });
      });
    }
    
    // Screen flash effect
    this.cameras.main.flash(1000, 255, 255, 255, false, (camera, progress) => {
      if (progress === 1) {
        console.log('Celebration effect complete');
      }
    });
  }

  nextLevel() {
    console.log('🚀 Moving to next level...');
    
    // Move to next level
    gameState.level++;
    gameState.startLevel(gameState.level);
    
    // Transition effect
    this.cameras.main.fadeOut(500, 0, 0, 0);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start('GameScene');
    });
  }
}